/*
  Cincy anti-spam: blocks form submissions where the hidden honeypot field
  (.cincy-hp__field) has been filled in — a signal that a bot, not a human,
  completed the form. Humans never see the field, so it must stay empty.
  Loaded by the contact and bulk-quote sections; guarded so it only runs once.
*/
(function () {
  if (window.__cincyAntispam) return;
  window.__cincyAntispam = true;

  function init() {
    var fields = document.querySelectorAll('.cincy-hp__field');
    Array.prototype.forEach.call(fields, function (field) {
      var form = field.closest('form');
      if (!form || form.dataset.cincyHpBound) return;
      form.dataset.cincyHpBound = 'true';
      form.addEventListener('submit', function (e) {
        if (field.value.trim() !== '') {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
